import React from "react";
import { Alert } from "react-bootstrap";

const AlertDisplay = (props) => {
  return (
    <Alert
      variant={props.alertType}
      onClose={() => props.setShowAlert(false)}
      dismissible
    >
      {props.alertText}
    </Alert>
  );
};

export default AlertDisplay;
